'use client'

import React from "react";
import { useInView } from 'react-intersection-observer';
import { motion } from 'framer-motion';
import { Container, Typography, Box, Grid } from '@mui/material';
import ModalImage from "react-modal-image";

export const DetailAngebotSection = ({ data }) => {
    const { ref, inView } = useInView({
        threshold: 0.1,
        triggerOnce: true,
    });


    return (
        <motion.section
            className="section-large"
            ref={ref}
            initial={{ opacity: 0 }}
            animate={{ opacity: inView ? 1 : 0 }}
            transition={{ duration: 1 }}
        >
            <div className="section-header">
                <div className="section-title">
                    <Typography variant="h3" component="h1" gutterBottom align="center">
                        {data.Titel}
                    </Typography>
                </div>
            </div>
            <div className="section-body">
                <Container maxWidth="lg">
                    <Typography variant="body1" color="text.secondary" paragraph sx={{ fontSize: { xs: '0.875rem', sm: '1rem' } }}>
                        {data.Beschreibung}
                    </Typography>
                    <Grid container spacing={4} alignItems="center" justifyContent={data.Bilder.length === 1 ? 'center' : 'flex-start'}>

                        {data.Bilder && data.Bilder.map((bild, index) => (
                            <Grid key={index} item xs={12} sm={6} md={4}>
                                <Box sx={{ my: 2, display: 'flex', justifyContent: 'center', height: 600, overflow: 'hidden' }}>
                                    <div style={{ borderRadius: '15px', overflow: 'hidden', display: 'inline-block' }}>
                                        <ModalImage
                                            small={bild}
                                            large={bild}
                                            alt={`Bild ${index + 1}`}
                                            hideDownload={false}
                                            hideZoom={false}
                                        />
                                    </div>

                                </Box>
                            </Grid>
                        ))}
                    </Grid>
                </Container>
            </div>
        </motion.section>
    );
};
